export default {"src":"/_next/static/media/seafood.937573a4.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};